export default __webpack_public_path__ + "static/media/icon-share.bd4f7d0e.svg";